import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import RadioBlock from '../../../../../../../components/Form/RadioBlock'
import Button from '../../../../../../../components/Button'
import Field from '../../../../../../../components/Form/Field'

import { formatOptionsList } from '../../../../../../../features/formatters'

import { lineItemsSelector } from '../../../../../../../modules/selectors/lineItems'

import { LINE_ITEM } from '../../../../../../Multiplatform/UploadAdCreative/UploadAdCreativeLineItemForm/fields'

import useStepFormStyles from '../../../../../../../styles/common/stepForms'
import {
  LIST_ITEM_OPTION,
  OPTION_EXISTING_LIST_ITEM,
  OPTION_NEW_LIST_ITEM
} from '../../../../../../../hooks/formHooks/listItemFormHooks/fields'

const stepFields = [LINE_ITEM]

const LineItemStep = ({ formik, handleStepChange, isOnlyLineItemStep }) => {
  const stepFormClasses = useStepFormStyles()
  const { t } = useTranslation()

  const lineItems = useSelector(lineItemsSelector)

  const { values, setFieldValue } = formik

  const formattedLineItems = formatOptionsList({
    list: lineItems,
    valueName: 'id',
    labelName: 'name'
  })

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <>
      <div className={stepFormClasses.stepTitle}>{t('Which line item should the ad be uploaded to?')}</div>
      <div className={stepFormClasses.stepBody}>
        <RadioBlock
          setFieldValue={setFieldValue}
          id="radio_existing_line_item"
          name={LIST_ITEM_OPTION}
          label={t('An existing line item')}
          value={OPTION_EXISTING_LIST_ITEM}
          selectedValue={values[LIST_ITEM_OPTION]}
        >
          <Field formik={formik} name={LINE_ITEM} placeholder={t('Select an line item')} options={formattedLineItems} />
        </RadioBlock>
        <RadioBlock
          setFieldValue={setFieldValue}
          id="radio_new_line_item"
          name={LIST_ITEM_OPTION}
          label={t('A new line item')}
          value={OPTION_NEW_LIST_ITEM}
          selectedValue={values[LIST_ITEM_OPTION]}
        />
      </div>
      {!isOnlyLineItemStep && (
        <div className={stepFormClasses.stepFooter}>
          <Button type="button" className="dark" onClick={handleContinue}>
            Continue
          </Button>
        </div>
      )}
    </>
  )
}

LineItemStep.propTypes = {
  formik: PropTypes.object.isRequired,
  handleStepChange: PropTypes.func,
  isOnlyLineItemStep: PropTypes.bool
}

export default LineItemStep
